import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import UserService from "../../services/userService";
import { handleApiError } from "../../api/handleApiError";

export const fetchAllDepartments = createAsyncThunk(
    "department/fetchAllDepartments",
    async (params = {}) => {
        return (await UserService.getAllDepartments(params)).data.data || [];
    }
);

export const createDepartment = createAsyncThunk(
    "department/createDepartment",
    async (payload, thunkAPI) => {
        try {
            return (await UserService.createDepartment(payload)).data.data;
        } catch (e) {
            return handleApiError(e, thunkAPI, "create department error");
        }
    }
);

export const updateDepartment = createAsyncThunk(
    "department/updateDepartment",
    async ({ id, data }, thunkAPI) => {
        try {
            return (await UserService.updateDepartment(id, data)).data.data;
        } catch (e) {
            return handleApiError(e, thunkAPI, "update department error");
        }
    }
);

export const deleteDepartment = createAsyncThunk(
    "department/deleteDepartment",
    async (id, thunkAPI) => {
        try {
            await UserService.deleteDepartment(id);
            return id;
        } catch (e) {
            return handleApiError(e, thunkAPI, "delete department error");
        }
    }
);

const departmentSlice = createSlice({
    name: "department",
    initialState: {
        departmentList: [],
        totalRecords: 0,
        loading: false,
        isSuccess: false,
        errorMessage: null,
    },
    reducers: {
        resetStatus: (state) => {
            state.isSuccess = false;
            state.errorMessage = null;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllDepartments.pending, (s) => {
                s.loading = true;
                s.errorMessage = null;
            })
            .addCase(fetchAllDepartments.fulfilled, (s, a) => {
                s.loading = false;
                s.departmentList = a.payload || [];
            })
            .addCase(fetchAllDepartments.rejected, (s, a) => {
                s.loading = false;
                s.errorMessage = a.payload || "Error";
            })
            .addCase(createDepartment.pending, (s) => {
                s.loading = true;
                s.isSuccess = false;
                s.errorMessage = null;
            })
            .addCase(createDepartment.fulfilled, (s, a) => {
                s.loading = false;
                s.isSuccess = true;
                if (a.payload) s.departmentList = [a.payload, ...(s.departmentList || [])];
            })
            .addCase(createDepartment.rejected, (s, a) => {
                s.loading = false;
                s.isSuccess = false;
                s.errorMessage = a.payload || "Error";
            })
            .addCase(updateDepartment.pending, (s) => {
                s.loading = true;
                s.isSuccess = false;
                s.errorMessage = null;
            })
            .addCase(updateDepartment.fulfilled, (s, a) => {
                s.loading = false;
                s.isSuccess = true;
                const updated = a.payload;
                if (!updated?.id) return;
                s.departmentList = (s.departmentList || []).map((d) => (d.id === updated.id ? updated : d));
            })
            .addCase(updateDepartment.rejected, (s, a) => {
                s.loading = false;
                s.isSuccess = false;
                s.errorMessage = a.payload || "Error";
            })
            .addCase(deleteDepartment.pending, (s) => {
                s.loading = true;
                s.isSuccess = false;
                s.errorMessage = null;
            })
            .addCase(deleteDepartment.fulfilled, (s, a) => {
                s.loading = false;
                s.isSuccess = true;
                s.departmentList = (s.departmentList || []).filter((d) => d.id !== a.payload);
            })
            .addCase(deleteDepartment.rejected, (s, a) => {
                s.loading = false;
                s.isSuccess = false;
                s.errorMessage = a.payload || "Error";
            });
    },
});

export const { resetStatus } = departmentSlice.actions;
export default departmentSlice.reducer;

